export const initializeUserData = async ({ dispatch }) => {
  await dispatch("auth/checkSession");
  dispatch("save/loadSaves");
  dispatch("account/loadAccounts");
};
